import { useEffect, useState } from "react";
import reactLogo from "./assets/react.svg";
import "./index.css";
import { Navigate, BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import PortalLayout from "./Components/PortalLayout";
import Dashboard from "./Pages/Dashboard/Dashboard";
import AdminPatients from "./Pages/Admin/Patients/AdminPatients";
import Doctors from "./Pages/Admin/Doctors/Doctors";
import Medicines from "./Pages/Admin/Medicines/Medicines";
import AddEditDoctors from "./Pages/Admin/Doctors/AddEditDoctors";
import RegisterUsers from "./Pages/Admin/RegisteredUsers/RegisterUsers";
import AddEditUsers from "./Pages/Admin/RegisteredUsers/AddEditUsers";
import LoginPage from "./Pages/Login/Login";
import Staff from "./Pages/Admin/Staff/Staff";
import AddEditStaff from "./Pages/Admin/Staff/AddEditStaff";
import AdminDashboard from "./Pages/Admin/Admin_Dashboard/AdminDashboard";
import AddEditPatient from "./Pages/Admin/Patients/AddEditPatient";
import PatientDetails from "./Pages/Admin/Patients/PatientDetails";
import Cookies from 'js-cookie';
import Roles from "./Pages/Admin/Roles/Roles";
import AddEditRoles from "./Pages/Admin/Roles/AddEditRoles";
import DutyRoster from "./Pages/Admin/Duty_Roster/duty";
import AddDuty from "./Pages/Admin/Duty_Roster/Addduty";
import EditDuty  from "./Pages/Admin/Duty_Roster/Editduty";
import Attendance from "./Pages/HR/Attendance/Attendance";
import { Toaster } from "react-hot-toast";
function App() {
  const [count, setCount] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isAuthenticated && location.pathname !== "/") {
      navigate("/login");
    }
  }, [isAuthenticated, location.pathname, navigate]);

  // Check authentication status on page load
  useEffect(() => {
    setIsAuthenticated(
      Boolean(Cookies.get("XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk="))
    );
  }, [location.pathname]);

  return (

       <>
       <Toaster />
       <Routes>
          <Route path="/" element={<Navigate to="/staff" replace />} />
          
          <Route path="/staff" element={isAuthenticated ? <PortalLayout> <Staff /> </PortalLayout> : <Navigate to="/login" />} />
          <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" />} />

          <Route path="/staff/AddEditStaff" element={isAuthenticated ? <PortalLayout>  <AddEditStaff /> </PortalLayout> : <Navigate to="/login" />} />

          <Route path="/doctor" element={isAuthenticated ? <PortalLayout> <Doctors /> </PortalLayout> : <Navigate to="/login" />} />
          <Route path="/doctor/AddEditDoctor" element={isAuthenticated ? <PortalLayout>  <AddEditDoctors /> </PortalLayout> : <Navigate to="/login" />} />

          <Route path="/roles" element={isAuthenticated ? <PortalLayout> <Roles /> </PortalLayout> : <Navigate to="/login" />} />
          <Route path="/roles/AddEditRoles" element={isAuthenticated ? <PortalLayout>  <AddEditRoles /> </PortalLayout> : <Navigate to="/login" />} />
          <Route path="/duty-roster"          element={isAuthenticated ? <PortalLayout><DutyRoster /></PortalLayout> : <Navigate to="/login" />} />
          <Route path="/duty-roster/add"      element={isAuthenticated ? <PortalLayout><AddDuty /></PortalLayout>    : <Navigate to="/login" />} />
          <Route path="/duty-roster/edit/:id" element={isAuthenticated ? <PortalLayout><EditDuty /></PortalLayout>   : <Navigate to="/login" />} />
          <Route path="/attendance" element={isAuthenticated ? <PortalLayout><Attendance /></PortalLayout> : <Navigate to="/login" />} />
  </Routes>
       </>
 
  );
}

export default App;
